export const INTENTION_LETTER_CHARS_PER_LINE = 80;

export function linesFromCharCount(charCount) {
  const n = Number(charCount) || 0;
  if (n <= 0) return 0;
  return Math.ceil(n / INTENTION_LETTER_CHARS_PER_LINE);
}

export function charLimitsFromLines(minLines, maxLines) {
  const mn = Math.max(0, parseInt(minLines, 10) || 0);
  const mx = Math.max(0, parseInt(maxLines, 10) || 0);
  return {
    minCharacters: mn * INTENTION_LETTER_CHARS_PER_LINE,
    maxCharacters: mx * INTENTION_LETTER_CHARS_PER_LINE,
  };
}

export function normalizeIntentionLetterText(raw) {
  if (raw == null) return '';
  return String(raw)
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .replace(/\n+/g, ' ')
    .trim();
}

export function validateIntentionLetterText(text, minLines, maxLines) {
  const normalized = normalizeIntentionLetterText(text);
  if (!normalized) {
    return { ok: false, message: 'Carta de intenção é obrigatória' };
  }
  const minL = Math.max(0, parseInt(minLines, 10) || 0);
  const maxL = Math.max(0, parseInt(maxLines, 10) || 0);
  const { minCharacters, maxCharacters } = charLimitsFromLines(minL, maxL);
  const charCount = normalized.length;
  const lineCount = linesFromCharCount(charCount);
  if (charCount < minCharacters) {
    return {
      ok: false,
      message: `Carta muito curta: mínimo ${minL} linha(s) (${minCharacters} caracteres)`,
    };
  }
  if (charCount > maxCharacters || lineCount > maxL) {
    return {
      ok: false,
      message: `Carta excede o máximo de ${maxL} linha(s) (${maxCharacters} caracteres)`,
    };
  }
  return { ok: true, normalized, charCount, lineCount };
}

export function sumRubricScores(rubric, scores) {
  if (!Array.isArray(rubric) || !scores || typeof scores !== 'object') return 0;
  return rubric.reduce((acc, row) => {
    const id = row?.id;
    const raw = id != null ? scores[id] : null;
    const val = parseFloat(raw);
    return acc + (Number.isFinite(val) ? val : 0);
  }, 0);
}

export const intentionLetterFieldStyle = {
  fontFamily: '"Roboto Mono", ui-monospace, monospace',
  fontSize: '12px',
  lineHeight: 1.5,
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  resize: 'vertical',
};
